export interface ColumnConfig {
  field: string;
  isSticky?: boolean;
  leftOffset?: number;
  rightOffset?: number;
  hasBorder?: boolean;
}

export const getFTDColumnConfig = (
  computedLeftOffsets: Record<number, number>,
  computedRightOffsets: Record<number, number>
): ColumnConfig[] => [
  { field: 'month', isSticky: true, leftOffset: computedLeftOffsets[0] },
  { field: 'empty', isSticky: true, leftOffset: computedLeftOffsets[1] }, // NRPU
  { field: 'empty', isSticky: true, leftOffset: computedLeftOffsets[2] }, // Growth Target
  { field: 'empty', isSticky: true, leftOffset: computedLeftOffsets[3] }, // Avg Net Rev
  { field: 'empty', isSticky: true, leftOffset: computedLeftOffsets[4] }, // CPA PV
  { field: 'empty', isSticky: true, leftOffset: computedLeftOffsets[5] }, // CVR
  { field: 'profit', isSticky: true, leftOffset: computedLeftOffsets[6], hasBorder: true }, // Profit
  { field: 'empty' }, // Active Users
  { field: 'empty' }, // Old Active Users
  { field: 'empty' }, // Acquired Users
  { field: 'ftd' }, // FTD
  { field: 'netRevenue' }, // Net Revenue
  { field: 'rs' }, // RS
  { field: 'empty' }, // RS PV
  { field: 'cpaIncome' }, // CPA Income
  { field: 'totalIncome' }, // Total Income
  { field: 'clicks' }, // Clicks
  { field: 'empty' }, // EPC CPA
  { field: 'empty' }, // EPC RS
  { field: 'empty' }, // EPC
  { field: 'empty' }, // CPC
  { field: 'empty' }, // CAC
  { field: 'spend' }, // Spend
  { field: 'empty', isSticky: true, rightOffset: computedRightOffsets[23] },
  { field: 'empty', isSticky: true, rightOffset: computedRightOffsets[24] },
  { field: 'empty', isSticky: true, rightOffset: computedRightOffsets[25] },
  { field: 'empty', isSticky: true, rightOffset: computedRightOffsets[26] },
];
